module.exports = __webpack_public_path__ + "static/media/icon-home.aa022509.png";